import api from './api';
import { Gateway, GatewayDetailsUpdate, GatewayListResponse, GatewayLocationUpdate } from '../types';

export const gatewayService = {
  async listGateways(): Promise<GatewayListResponse> {
    const response = await api.get<GatewayListResponse>('/api/gateways/');
    return response.data;
  },

  async getGateway(gatewayId: string): Promise<Gateway> {
    const response = await api.get<Gateway>(`/api/gateways/${encodeURIComponent(gatewayId)}`);
    return response.data;
  },

  async updateGatewayLocation(gatewayId: string, location: string | null): Promise<Gateway> {
    const body: GatewayLocationUpdate = { location };
    const response = await api.patch<Gateway>(`/api/gateways/${encodeURIComponent(gatewayId)}/location`, body);
    return response.data;
  },

  async updateGatewayDetails(gatewayId: string, body: GatewayDetailsUpdate): Promise<Gateway> {
    const response = await api.patch<Gateway>(`/api/gateways/${encodeURIComponent(gatewayId)}`, body);
    return response.data;
  },

  async syncGateways(): Promise<GatewayListResponse> {
    const response = await api.post<GatewayListResponse>('/api/gateways/sync');
    return response.data;
  },
};
